import React from 'react';
import { Box, Stepper, Step, StepLabel, StepIconProps } from '@mui/material';
import { getPasosCompra, pasosCompraBase } from 'utils/constants';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { theme } from 'theme/theme';

const CustomStepIcon = (props: StepIconProps & { error?: boolean }) => {
  const { active, completed, icon, error } = props;

  const baseStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 24,
    height: 24,
    borderRadius: '50%',
    color: 'white',
    fontSize: 14,
  };

  if (error) {
    return <CancelIcon sx={{ ...baseStyle, backgroundColor: 'red' }} />;
  } else if (completed) {
    return <CheckCircleIcon sx={{ ...baseStyle, backgroundColor: 'green' }} />;
  } else if (active && icon === pasosCompraBase.length + 1) {
    return <CheckCircleIcon sx={{ ...baseStyle, backgroundColor: 'green' }} />;
  } else if (active) {
    return <Box sx={{ ...baseStyle, backgroundColor: theme.palette.primary.main }}>{icon}</Box>;
  } else {
    return <Box sx={{ ...baseStyle, backgroundColor: 'lightgray' }}>{icon}</Box>;
  }
};

const PasosDeCompra = ({ paso, error }: { paso: number; error?: boolean }) => {
  const pasosCompra = getPasosCompra();
  return (
    <Box sx={{ width: '100%', py: 4 }}>
      <Stepper activeStep={paso} alternativeLabel>
        {pasosCompra.map((label, index) => (
          <Step key={label}>
            <StepLabel StepIconComponent={props => <CustomStepIcon {...props} error={error && paso === index} />}>
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default PasosDeCompra;
